import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function notWhiteSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const regex = /^\S*$/;
    const value = control.value;
    if (regex.test(value)) {
      return null;
    } else {
      return {
        notWhiteSpaces: {
          notWhiteSpaces: true,
          data: value
        }
      };
    }
  }
}


/** Funcion para validaciones de fecha inicio vs fecha fin usar conmo validador en definicion del form
 * importante enviar fecha 1 y fecha 2 a comparar
 * realiza validacion de que fecha 2 no puede ser menor a la fecha 1
 */
export function dateGreaterThanValidator(fechaInicioKey: string, fechaFinKey: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fechaInicio = control.get(fechaInicioKey)?.value;
    const fechaFin = control.get(fechaFinKey)?.value;

    if (!fechaInicio || !fechaFin) return null;
    
    const inicio = new Date(fechaInicio);
    const fin = new Date(fechaFin);

    if (fin < inicio) return { dateRangeInvalid: true };
    
    return null;
  };
}

